/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />

module Meevo.Plugins.AdpIntegration {
    "use strict";
    
    export abstract class AdpIntegrationContext extends Meevo.Components.CommonClasses.CommonContextBase {
        protected busyService: Components.Busy.IBusyService;
        protected rootScope: ng.IRootScopeService;
        protected state: any;

        protected employeeSection: EmployeeSection = null;
        protected commissionSection: CommissionSection = null;
        protected mainSection: MainSection = null;
        protected compensationSettingsEndPoint: string;
        protected contextParams: Meevo.ContextParamsService

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            busyService: Meevo.Components.Busy.IBusyService,
            $rootScope: ng.IRootScopeService,
            protected $translate: angular.translate.ITranslateService,
            contextParams: Meevo.ContextParamsService
           ) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);
            this.contextParams = contextParams;
            this.busyService = busyService;
            this.rootScope = $rootScope;
            this.compensationSettingsEndPoint = appSettings.API_ENDPOINTS.compensationSettings;

            this.Init();

            this.initializeSections();
        }

        abstract Init(): void;
     

        initializeHeader(model: any): void {
            this.headerContent = model.storeName;            
        }

        selectSection(item): void {
            super.selectSection(item);

            this.auditNoun = this.selectedSection.noun;
            this.buildCrudSecurityKeysBase(this.selectedSection.sectionSecurityKey.replace(Meevo.Components.Common.SecurityParts.KEY_PART_READ, ''))
        }

        edit(): void {
            super.edit();
            if (this.selectedSection === this.employeeSection) {
                this.modalService.confirm('LABEL_ADP_CONFIRM_UPDATE_WORKERS').then(response => {
                    if (!!response) {
                        this.employeeSection.updateAdpWorker();
                    }
                }); 
            }

            if (this.selectedSection === this.commissionSection) {
                this.modalService.confirm('LABEL_ADP_CONFIRM_UPDATE_EARNINGCODES').then(response => {
                    if (!!response) {
                        this.commissionSection.updateAdpCommissions();
                    }
                });
            }
        }

        public refresh(): void {
            this.selectedSection = null;
            this.mainSection.isLoaded = false;
            this.selectSection(this.mainSection);
        }

        public updateADPCredentials(): void {
            this.busyService.start();
            this.dataService.getSection("adpintegration", `${this.selectedSection.model.connectorId}/RefreshAdpCredentials`).then((data: any) => {
                if (data) {
                    this.modalService.info("ADP Credentials have been successfully updated");
                }
                else {
                    this.modalService.warning("ADP Credentials failed to update. Contact Development.");
                }
            }).finally(() => { this.busyService.stop(); });
        }

        abstract goToMarketplace(): void;
        abstract goToConsent(): void;
        abstract goToAdpLogin(): void;        
    }
}
